import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import {
  Button,
  CardActions,
  CircularProgress,
  withStyles,
} from '@material-ui/core';
import {
  PasswordField,
  renderFormFieldInput as renderInput,
} from '../components';
import { formStyles as styles } from '../styles';
import { validatePassword as validate } from '../../util/validation';

const ChangePasswordForm = withStyles(styles)(props => {
  const { requestChangePassword, overridePasswordValidation } = props;
  const [isLoading, setIsLoading] = useState(false);
  const translate = useTranslate();

  const validatePassword = values =>
    overridePasswordValidation
      ? overridePasswordValidation(values, { translate })
      : validate(values, { translate });

  return (
	<Form
		validate={values => {
        return validatePassword(values);
		}}
		onSubmit={values => {
        requestChangePassword(values, setIsLoading);
		}}
		{...props}
	>
		{({ classes, handleSubmit, submitting }) => (
			<form onSubmit={handleSubmit}>
				<div className={classes.form}>
					<p>
						{translate('authentication.forceChangePassword.cardContent', {
                _: 'Please change your password to continue signing in.',
              })}
					</p>
					<div className={classes.input}>
						<PasswordField
							isFormLoading={isLoading || submitting}
							fieldComponent={renderInput}
              />
					</div>
				</div>
				<div className={classes.cardActions}>
					<CardActions>
						<Button
							type="submit"
							disabled={isLoading}
							color="primary"
							className={classes.button}
						>
							{isLoading ? (
								<CircularProgress
									size={25}
									thickness={3}
									className={classes.loadingIndicator}
                  />
                ) : (
                  translate('authentication.forceChangePassword.submit', {
                    _: 'Change Password',
                  })
                )}
						</Button>
					</CardActions>
				</div>
			</form>
      )}
	</Form>
  );
});

ChangePasswordForm.propTypes = {
  classes: PropTypes.object,
  requestChangePassword: PropTypes.func.isRequired,
  overridePasswordValidation: PropTypes.func,
};

ChangePasswordForm.defaultProps = {
  classes: null,
  overridePasswordValidation: null,
};

export default ChangePasswordForm;
